export default "__VITE_ASSET__DkYTEkXs__"